// extracted by mini-css-extract-plugin
export var brTab = "style-module--brTab--da633";
export var description = "style-module--description--58169";